<template>
  <div
    class="cycles-toolbar d-flex align-center justify-space-between flex-wrap"
    data-testid="bookclosure-project-list__filter-section"
  >
    <div class="cycles-toolbar__left">
      <CycleStatusTabs
        :value="cyclesFilters.statusTab"
        :disabled="disabled"
        @input="onStatusTabChange"
      />
      <SearchBar
        :value="cyclesFilters.search"
        placeholder="Search"
        data-testid-prefix="cycles-page__search"
        :disabled="disabled"
        @input="onSearchChange"
      />
    </div>

    <div
      class="cycles-toolbar__right"
      data-testid="bookclosure-project-list__filter-container"
    >
      <v-btn
        v-if="hasActiveDropdownFilters"
        text
        class="cycles-toolbar__clear-filter text-none"
        :disabled="disabled"
        data-testid="bookclosure-project-list__clear-filter-btn"
        @click="onClearDropdownFilters"
      >
        Clear Filter
      </v-btn>

      <SearchableMultiSelectDropdown
        :value="cyclesFilters.locations"
        :items="filterOptions.locations || []"
        label="Location"
        placeholder="All"
        icon="/img/icons/fbc-icons/LocationFilter.svg"
        data-testid-prefix="cycles-page__filter-location"
        :disabled="disabled"
        @input="onMultiSelectChange('locations', $event)"
      />

      <SearchableMultiSelectDropdown
        :value="cyclesFilters.users"
        :items="filterOptions.users || []"
        label="Users"
        placeholder="All"
        icon="/img/icons/UserFilterIcon.svg"
        data-testid-prefix="cycles-page__filter-users"
        :disabled="disabled"
        @input="onMultiSelectChange('users', $event)"
      />

      <SearchableMultiSelectDropdown
        v-if="upsiEnabled"
        :value="cyclesFilters.upsiStatuses"
        :items="upsiStatusOptions"
        label="UPSI"
        placeholder="All"
        icon="mdi-information-outline"
        data-testid-prefix="cycles-page__filter-upsi"
        :disabled="disabled"
        @input="onMultiSelectChange('upsiStatuses', $event)"
      />

      <PeriodFilterDropdown
        :value="cyclesFilters.periods"
        :available-month-tokens="filterOptions.availableMonthTokens || []"
        :disabled="disabled"
        @input="onMultiSelectChange('periods', $event)"
      />
    </div>
  </div>
</template>

<script>
import './CyclesToolbar.scss';
import {
  SearchBar,
  SearchableMultiSelectDropdown,
  PeriodFilterDropdown,
} from '../../../../components';
import CycleStatusTabs from '../CycleStatusTabs/CycleStatusTabs.vue';
import { DEFAULT_CYCLES_FILTERS, createInitialCyclesFilter } from '../../utils/cyclesConstants';
import { UPSI_STAGE_LABELS } from '../../../../utils/constants';
import { isCustomPeriodFilter } from '../../../../utils/periodHelpers';

export default {
  name: 'CyclesToolbar',

  components: {
    CycleStatusTabs,
    SearchBar,
    SearchableMultiSelectDropdown,
    PeriodFilterDropdown,
  },

  props: {
    cyclesFilters: {
      type: Object,
      default: () => ({ ...DEFAULT_CYCLES_FILTERS }),
    },
    filterOptions: {
      type: Object,
      default: () => ({
        locations: [],
        users: [],
        periods: [],
        availableMonthTokens: [],
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    upsiEnabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    upsiStatusOptions() {
      return Object.keys(UPSI_STAGE_LABELS).map((stage) => ({
        _id: String(stage),
        label: UPSI_STAGE_LABELS[stage],
      }));
    },
    hasActiveDropdownFilters() {
      const defaults = createInitialCyclesFilter();
      const filters = { ...defaults, ...(this.cyclesFilters || {}) };
      if ((filters.locations || []).length > 0) return true;
      if ((filters.users || []).length > 0) return true;
      if ((filters.upsiStatuses || []).length > 0) return true;
      return isCustomPeriodFilter(filters.periods);
    },
  },

  methods: {
    emitFilters(patch) {
      this.$emit('update:cyclesFilters', {
        ...DEFAULT_CYCLES_FILTERS,
        ...(this.cyclesFilters || {}),
        ...patch,
      });
    },

    onStatusTabChange(statusTab) {
      this.emitFilters({ statusTab });
    },

    onSearchChange(search) {
      this.emitFilters({ search: search || '' });
    },

    onMultiSelectChange(key, value) {
      this.emitFilters({ [key]: Array.isArray(value) ? value : [] });
    },

    onClearDropdownFilters() {
      const defaults = createInitialCyclesFilter();
      this.emitFilters({
        locations: [],
        users: [],
        periods: [...defaults.periods],
        upsiStatuses: [],
      });
    },
  },
};
</script>
